import { useEffect } from 'react';

export function useGamepadVibration(shouldVibrate: boolean) {
  useEffect(() => {
    if (!shouldVibrate) return;

    const interval = setInterval(() => {
      const gamepads = navigator.getGamepads();
      for (const gamepad of gamepads) {
        if (gamepad && 'vibrationActuator' in gamepad) {
          const actuator = gamepad.vibrationActuator;
          if (actuator && actuator.playEffect) {
            // Play a pulsing pattern - 200ms vibration, 400ms pause
            actuator.playEffect('dual-rumble', {
              startDelay: 0,
              duration: 200,
              weakMagnitude: 0.5,
              strongMagnitude: 0.5,
            });
          }
        }
      }
    }, 600); // Total pattern duration (200ms vibration + 400ms pause)

    return () => {
      clearInterval(interval);
    };
  }, [shouldVibrate]);
}
